import Logo from './image/logo.png';
import ProfileImage from './image/profile.png';
import HuggingFace from './image/HuggingFace.png';
import CourceComplete from './image/cource-complete.png';
import FormulaOne from './image/formula-one.png';
import FormulaTwo from './image/formula-two.png';
import ReadyToTest from './image/ready-to-test.png';
import ResultGood from './image/result-good.png';
import ResultBad from './image/result-bad.png';

const assets = {
  Logo,
  ProfileImage,
  HuggingFace,
  CourceComplete,
  FormulaOne,
  FormulaTwo,
  ReadyToTest,
  ResultGood,
  ResultBad,
};
export default assets;
